import { useState } from "react";

import cx from "@hsl/core/utils/cx";

import Tab, { type Tab as ITab } from "./components/Tab";

export interface TabsColumnProps {
    content?: (React.ReactNode | (() => React.ReactNode))[];
    className?: string;
    contentContainerClassName?: string;
    tabClassName?: string;
    tabs: ITab[];
    activeIndex?: number;
    onChange?(activeIndex: number): void;
    variant?: "default" | "blue" | "radio";
}

const TabsColumn = ({
    content = [],
    className,
    contentContainerClassName,
    tabClassName,
    tabs = [],
    activeIndex,
    onChange,
    variant = "default",
}: TabsColumnProps) => {
    const [activeTabIndex, setActiveTabIndex] = useState(activeIndex ?? 0);

    const handleTabClick = (index: number) => {
        setActiveTabIndex(index);
        !!onChange && onChange(index);
    };

    return (
        <div className={cx("flex", variant === "radio" && "mt-1", className)}>
            <nav
                aria-label="Tabs"
                className={cx({
                    "border-r border-gray-100 pr-12": variant === "default",
                    "mr-10 w-56 shrink-0": variant === "blue",
                    "border-battleship-grey w-64 border-t pt-3":
                        variant === "radio",
                })}
            >
                {tabs.map((tab, i) => {
                    return (
                        <Tab
                            tab={tab}
                            key={tab.key}
                            current={activeTabIndex === i}
                            className={cx(tabClassName, "z-40")}
                            onClick={() => handleTabClick(i)}
                            variant={variant}
                        />
                    );
                })}
            </nav>
            {/* CONTENT */}
            {content.length > 0 && (
                <div
                    className={cx(
                        {
                            "pl-8": variant === "default",
                            "pl-16 pt-3": variant === "radio",
                        },
                        contentContainerClassName,
                    )}
                >
                    {content.map((elem, i) => (
                        <div
                            key={`${i}-content`}
                            className={cx(i !== activeTabIndex && "hidden")}
                        >
                            {typeof elem === "function" ? elem() : elem}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default TabsColumn;
